import React, { useMemo, useState } from 'react';

const Numero = ({ label, value, onChange, suffix }) => <div className='form-group col-md-4'>
    <label>{label}</label>
    <div className='input-group'>
        <input className='form-control' type='number' min='0' step='0.01'
            value={value} onChange={e => onChange(e.target.value)} />
        {suffix && <div className='input-group-append'><span className='input-group-text'>{suffix}</span></div>}
    </div>
</div>;

const Resultado = ({ children }) => <div className='alert alert-success mt-3'
    style={{ fontSize: 18, fontWeight: 600 }}>{children}</div>;

export default () => {
    const [tipo, setTipo] = useState('distribuidor');
    const [largura, setLargura] = useState('');
    const [velocidade, setVelocidade] = useState('');
    const [dose, setDose] = useState('');
    const [distancia, setDistancia] = useState('');
    const [sementes, setSementes] = useState('');
    const [espacamento, setEspacamento] = useState('');
    const [vazao, setVazao] = useState('');
    const numero = valor => Number(String(valor).replace(',', '.')) || 0;
    const resultado = useMemo(() => {
        if (tipo === 'plantadeira') {
            const metros = 10000 / Math.max(numero(espacamento), 0.0001);
            return numero(sementes) && numero(espacamento)
                ? `${(numero(sementes) / metros).toFixed(2)} sementes por metro linear`
                : 'Preencha a população e o espaçamento.';
        }
        if (tipo === 'pulverizador') {
            const litros = numero(vazao) * 600 / Math.max(
                numero(velocidade) * numero(espacamento), 0.0001
            );
            return numero(vazao) && numero(velocidade) && numero(espacamento)
                ? `${litros.toFixed(2)} L/ha`
                : 'Preencha vazão, velocidade e espaçamento.';
        }
        const quantidade = numero(dose) * numero(largura) * numero(distancia) / 10000;
        return numero(dose) && numero(largura) && numero(distancia)
            ? `${quantidade.toFixed(2)} kg devem ser coletados no percurso`
            : 'Preencha dose, largura e distância.';
    }, [tipo, largura, velocidade, dose, distancia, sementes, espacamento, vazao]);
    return <div>
        <div className='btn-group mb-3'>
            {[['distribuidor', 'Distribuidor'], ['plantadeira', 'Plantadeira'],
                ['pulverizador', 'Pulverizador']].map(item =>
                <button key={item[0]} type='button'
                    className={`btn ${tipo === item[0] ? 'btn-success' : 'btn-light'}`}
                    onClick={() => setTipo(item[0])}>{item[1]}</button>)}
        </div>
        <div className='row'>
            {tipo === 'distribuidor' && <>
                <Numero label='Dose desejada' suffix='kg/ha' value={dose} onChange={setDose} />
                <Numero label='Largura de trabalho' suffix='m' value={largura} onChange={setLargura} />
                <Numero label='Distância do teste' suffix='m' value={distancia} onChange={setDistancia} />
            </>}
            {tipo === 'plantadeira' && <>
                <Numero label='População desejada' suffix='sementes/ha'
                    value={sementes} onChange={setSementes} />
                <Numero label='Espaçamento entre linhas' suffix='m'
                    value={espacamento} onChange={setEspacamento} />
            </>}
            {tipo === 'pulverizador' && <>
                <Numero label='Vazão por bico' suffix='L/min' value={vazao} onChange={setVazao} />
                <Numero label='Velocidade' suffix='km/h' value={velocidade} onChange={setVelocidade} />
                <Numero label='Espaçamento entre bicos' suffix='m'
                    value={espacamento} onChange={setEspacamento} />
            </>}
        </div>
        <Resultado>{resultado}</Resultado>
        <button className='btn btn-outline-secondary' type='button' onClick={() => window.print()}>
            <i className='fas fa-print mr-2' />Imprimir ficha
        </button>
    </div>;
};
